// Copyright (c) 2017 Deere & Company

export const getClassName = (className, count) =>
    count > 0 ? className : '';



// WEBPACK FOOTER //
// ./src/reports/audit-status/services/get-class-name.js